export default __webpack_public_path__ + "static/media/Info.34d14815.svg";